import _ from "lodash";
import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Table, Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { adminAPI } from "redux/api";

import { apiUrls } from "./init";

import { LoadingIcon, setOnChange } from "components/special";

const { api } = adminAPI.actions;

const SpecialsSourcePrompt = (props) => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(false);
  const [prompt, setPrompt] = useState({});
  const [modalOpen, setModalOpen] = useState(false);

  const changeContent = setOnChange(prompt, setPrompt);

  const toggleModal = () => setModalOpen(!modalOpen);

  useEffect(() => {
    if (modalOpen) {
      props.getPromptValue(
        {},
        {
          onSuccess(body) {
            setLoading(false);
            setPrompt(body);
          },
          onRequest() {
            setPrompt({});
            setLoading(true);
            setError(false);
          },
          onFailure() {
            setLoading(false);
            setError(true);
          },
        },
      );
    }
  }, [modalOpen]);

  const saveHandler = () => {
    const confirmed = window.confirm("Сохранить?");

    if (confirmed) {
      const onSuccess = (body) => {
        setSaving(false);
      };
      const onRequest = () => {
        setSaving(true);
      };
      const onFailure = () => {
        setSaving(false);
      };
      props.savePromptValue({ body: prompt }, { onSuccess, onRequest, onFailure });
    }
  };

  return (
    <>
      <button className="btn btn-sm -btn-secondary" onClick={toggleModal}>
        <i className={`fa fa-cog ${loading ? "fa-spin" : ""}`} />
      </button>
      {modalOpen ? (
        <Modal size="lg" toggle={toggleModal} isOpen={true}>
          <ModalHeader toggle={toggleModal}></ModalHeader>
          <ModalBody>
            {loading ? (
              <LoadingIcon />
            ) : (
              <>
                {prompt._id ? (
                  <div>
                    <div className="h2">Базовый промпт</div>
                    <div>
                      К указанному сообщению будут добавлены роль и ссылка из значений rss-источника
                    </div>
                    <div className="py-2">
                      <textarea
                        class="form-control"
                        autoComplete="off"
                        rows={10}
                        name="text"
                        value={prompt.text}
                        onChange={changeContent}
                      />
                    </div>
                    <div>
                      <Button className="btn btn-success" onClick={saveHandler}>
                        {saving ? <LoadingIcon className="mr-2" /> : null}
                        Сохранить
                      </Button>
                    </div>
                  </div>
                ) : (
                  <>{"Ошибка загрузки"}</>
                )}
              </>
            )}
          </ModalBody>
        </Modal>
      ) : null}
    </>
  );
};

export default connect(null, {
  getPromptValue: api.get(apiUrls.source_prompt),
  savePromptValue: api.post(apiUrls.source_prompt),
})(SpecialsSourcePrompt);
